import { z } from 'zod'

// Condition operators for visibility rules
const CONDITION_OPS = [
  '=',
  '!=',
  '>',
  '<',
  '>=',
  '<=',
  'in',
  'not_in',
  'is_null',
  'is_not_null',
  'is_truthy',
  'is_falsy',
] as const

export const ConditionSchema = z.object({
  field: z.string(),
  op: z.enum(CONDITION_OPS),
  value: z
    .union([
      z.string(),
      z.number(),
      z.boolean(),
      z.array(z.string()),
      z.array(z.number()),
      z.null(),
    ])
    .optional(),
})

export type Condition = z.infer<typeof ConditionSchema>

// Form layout item - defines which section to show and when
export const FormLayoutItemSchema = z.object({
  sectionId: z.string(),
  showWhen: z.array(ConditionSchema).default([]),
})

export type FormLayoutItem = z.infer<typeof FormLayoutItemSchema>
